import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { TerminalInfo } from "../GQLCalls/getTerminalsCall";


export type TerminalItem = DynamicDataObk<TerminalInfo[]>

const terminalsDataAdapter = createEntityAdapter({
  selectId: (item: TerminalItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<TerminalItem, string>, {con, data}: TerminalItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "terminal_id")
    data.forEach((entry) => dataDictionary[entry.terminal_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    terminalsDataAdapter.upsertOne(state, newPayload);
  } else { terminalsDataAdapter.addOne(state, {con, data})}
}

const terminalsSlice = createSlice({
  name: "terminals",
    initialState: terminalsDataAdapter.getInitialState<TerminalItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<TerminalItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const TerminalsActions = terminalsSlice.actions;
export default terminalsSlice.reducer;